<template lang="html">
    <div class="article">
        <div class="banner-img">
        </div>
        <div class="container">
            <p>全医佳新闻资讯列表 / <span>内容详情</span></p>
            <div class="content">
                <h2>北京健康扶贫基金会与全医佳达成战略合作伙伴</h2>
                <p>
                    2016年12月1日，江苏全医佳电子商务有限公司副总经理谢玉丹来我会签订一站式医疗设备服务平台项目合作协议书，我会执行理事长朱定良、调研部主任秦燕参与了此次合作协议签订会。
                    江苏全医佳电子商务有限公司是中国为完善医疗设备服务市场而搭建的综合性纯服务类电商平台。现已联合国内上百家医院、1500多家供应商共同建立联盟性行业生态链，利用互联网开拓信息渠道，颠覆传统的服务运营模式。
                </p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/2.jpg" alt="">
                </div>
                <p>“一站式医疗设备服务平台”项目是以提升基层卫生服务能力项目为契机，对基层医疗设备管理进行积极探索，双方致力共同携手通过项目发挥基层医疗设备的最大潜力，优化医疗设备资源配置、为基层群众提供更优质、更高效的医疗服务。
                    此次框架合作协议的签订，意味着我会与江苏全医佳电子商务有限公司达成战略合作伙伴，下一步双方将就项目具体运行进行详细沟通。
                </p>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
    name:'article1',
    components: {
        Foot
    }
}
</script>

<style lang="scss" scoped>
    .article{
        letter-spacing: 1px;
        background: #F6F8FA;
        color: #000;
        .banner-img{
            margin-top: $highlight-height;
            height: 140px;
            background: url("https://static.qyjmed.com/webSite/productService/document/bg.png") center;
        }
        .container{
            >p{
                font-size: 18px;
                line-height: 76px;
                span{
                    color: #4EAAFC;
                }
            }
            .content{
                min-height: 600px;
                background: white;
                padding: 0 70px 70px;
                margin-bottom: 30px;
                h2{
                    font-size: 22px;
                    text-align: center;
                    font-weight: 400;
                    padding:46px 0 20px;
                }
                p{
                    line-height: 40px;
                    text-indent: 2rem;
                }
                div{
                    text-align: center;
                    img{
                        width: 900px;
                        padding:10px 0;
                    }
                }
            }
        }
    }
</style>
